<template>

<!--第一行-->
  <el-row  style="margin-top: 5px;">
    <el-col :span="2" :offset="2" style="text-align: right;">
      <span>所属项目：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.project_name}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>任务编号：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.id}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>任务名称：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.name}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>关联数据类别：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.related_data_type_name}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>所属阶段：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.stage_name}}</span>
    </el-col>
  </el-row>

<!--第二行-->
  <el-row  style="margin-top: 5px;">
    <el-col :span="2" :offset="2" style="text-align: right;">
      <span>创建人：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.create_user_name}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>任务状态：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.status_name}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>计划人天：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.plan_man_day}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>计划开始日期：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.plan_start_date}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>计划完成日期：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.plan_end_date}}</span>
    </el-col>
  </el-row>

<!--  第三行-->
  <el-row  style="margin-top: 5px;">
    <el-col :span="2" :offset="2" style="text-align: right;">
      <span>责任人：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.charge_user_name}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>进度(%)：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.progress_percent}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>实际人天：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.actual_man_day}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>实际开始时间：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.actual_start_date}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>实际完成时间：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.actual_end_date}}</span>
    </el-col>
  </el-row>

  <el-row style="margin-top: 5px;margin-bottom: 20px">
    <!--  功能栏位-->
    <el-col :span="12" :offset="6" style="text-align: center;padding: 5px;background-color: #efefef">
      <el-button size="small" style="margin-right: 10px" @click="dialogs.showAssign = true" :disabled="disableButton">更改责任人</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitClaimTask" :disabled="claimButton">任务领取</el-button>
      <el-button size="small" style="margin-right: 10px" @click="showChangeProgress" :disabled="memberButton">更改进度</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitUrgeReminder" :disabled="reminderButton">催促提醒</el-button>
      <el-button size="small" style="margin-right: 10px" @click="showCompleteTask" :disabled="memberButton">完成任务</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitAbortTask" :disabled="abortButton">中止</el-button>
      <el-button size="small" style="margin-right: 10px" @click="cancelAbortTask" :disabled="cancelAbortButton">取消中止</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitPausedTask" :disabled="pausedButton">挂起</el-button>
      <el-button size="small" style="margin-right: 10px" @click="cancelPausedTask" :disabled="cancelPausedButton">取消挂起</el-button>
    </el-col>
  </el-row>

  <el-row style="overflow-y: auto;max-height: 750px;padding: 20px">
<!--    左侧回复内容-->
    <el-col :span="18" >
      <div style="padding: 0px 5px 0px 5px">
        <el-row style="line-height: 24px;height: 24px;border: 1px solid #e5e5e5;background-color: whitesmoke">
          <el-col :span="20" style="text-align: left;">
            <span style="color: #666666;margin-left: 5px;">{{mainData.name}}</span>
          </el-col>
          <el-col :span="4" style="text-align: right;">
            <span style="color: #666666;margin-right: 5px;">{{mainData.id}}</span>
          </el-col>
        </el-row>

        <div style="border: 1px solid #e5e5e5;">
          <KfCkEditor :model-value="mainData.name" readonly></KfCkEditor>
        </div>
        <el-row style="font-size: smaller; line-height: 24px;height: 24px;border: 1px solid #e5e5e5;background-color: whitesmoke">
          <el-col :span="24" style="text-align: right;">
            <span style="color: #666666;margin-right: 10px;">楼主</span>
            <span style="color: #666666;margin-right: 10px;">{{mainData.create_user_name}}</span>
            <span style="color: #666666;margin-right: 10px;">{{mainData.create_time}}</span>
          </el-col>
        </el-row>

        <div v-for="(item, index) in replyList" :key="index">
          <div style="border: 1px solid #e5e5e5;">
            <KfCkEditor :model-value="item.content" readonly  ></KfCkEditor>
          </div>
          <el-row style="font-size: smaller; line-height: 24px;height: 24px;border: 1px solid #e5e5e5;background-color: whitesmoke">
            <el-col :span="24" style="text-align: right;">
              <span style="color: #666666;margin-right: 10px;">第{{index+1}}楼</span>
              <span style="color: #666666;margin-right: 10px;">{{item.create_user_name}}</span>
              <span style="color: #666666;margin-right: 10px;">{{item.create_time}}</span>
              <span v-if="item.create_user_id === mainData.current_user_id" style="color: #6699CC;margin-left: 10px;" @click="delReply(item)">删除</span>
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 10px;">添加回复</div>
        <div style="margin-top: 3px;border: 1px solid #e5e5e5;">
          <KfCkEditor v-model="replyContent" ></KfCkEditor>
        </div>
        <div style="margin-top: 5px">
          <el-button size="small" @click="submitReply" >提交回复</el-button>
        </div>
      </div>
    </el-col>

<!--    右侧最新动态-->
    <el-col :span="6">
      <div style="min-height: 600px;border: 1px solid #e5e5e5;" >
        <div style="border: 1px solid #e5e5e5;background-color: whitesmoke;padding-left: 5px">
          最新动态
        </div>
        <div v-for="(item, index) in logList" :key="index">
          <el-row style="font-size: smaller; line-height: 24px;height: 24px;border: 1px solid #e5e5e5;">
            <el-col :span="24" style="text-align: left;padding-left: 5px">
              <span style="color: #666666;margin-right: 10px;">{{item.create_time}}</span>
              <span style="color: #666666;margin-right: 10px;">{{item.create_user_name}}</span>
              <span style="color: #666666;margin-right: 10px;">{{item.content}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-col>
  </el-row>

  <!-- 更改责任人 对话框 -->
  <el-dialog title="更改责任人" v-model="dialogs.showAssign" :close-on-click-modal="false" width="450px">
    <el-form v-model="assignData" label-width="90px">
      <el-form-item label="责任人" required>
        <el-select v-model="assignData.charge_user_id" placeholder="更改到" clearable style="width: 90%">
          <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-row style="justify-content: center;width: 100%;margin-top: 10px">
        <el-button type="primary" @click="submitAssign">确定</el-button>
        <el-button @click="dialogs.showAssign = false">取消</el-button>
      </el-row>
    </el-form>
  </el-dialog>

<!--  更改任务名称 对话框-->
  <el-dialog title="更改任务名称" v-model="dialogs.showEditName" :close-on-click-modal="false" width="450px">
    <el-form v-model="nameData" label-width="90px">
      <el-form-item label="任务名称" required>
        <el-input v-model="nameData.name" style="width: 90%"></el-input>
      </el-form-item>
      <el-row style="justify-content: center;width: 100%;margin-top: 10px">
        <el-button type="primary" @click="submitEditName">确定</el-button>
        <el-button @click="dialogs.showEditName = false">取消</el-button>
      </el-row>
    </el-form>
  </el-dialog>

<!--  更改进度 对话框-->
  <el-dialog title="更改进度" v-model="dialogs.showChangeProgress" :close-on-click-modal="false" width="450px">
    <el-form v-model="progressData" label-width="120px">
      <el-form-item label="进度(%)" required>
        <el-input-number v-model="progressData.progress_percent" :min="0" :max="99" style="width: 80%">
          <template #suffix>
            <span>%</span>
          </template>
        </el-input-number>
      </el-form-item>
      <el-row style="justify-content: center;width: 100%;margin-top: 10px">
        <el-button type="primary" @click="submitChangeProgress">确定</el-button>
        <el-button @click="dialogs.showChangeProgress = false">取消</el-button>
      </el-row>
    </el-form>
  </el-dialog>

<!--  催促提醒 对话框-->
  <el-dialog title="催促提醒" v-model="dialogs.showUrgeReminder" :close-on-click-modal="false" width="450px">
    <el-form v-model="progressData" label-width="110px">
      <el-form-item label="进度(%)" required>
        <el-input-number v-model="progressData.progress_percent" :min="0" :max="99">
          <template #suffix>
            <span>%</span>
          </template>
        </el-input-number>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="submitChangeProgress">确定</el-button>
        <el-button @click="dialogs.showUrgeReminder = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
  <!-- 完成任务 对话框 -->
  <el-dialog title="完成任务" v-model="dialogs.showCompleteTask" :close-on-click-modal="false" width="500px">
    <el-form v-model="taskData" label-width="110px">
      <el-form-item label="进度(%)" required>
        <el-input-number v-model="taskData.progress_percent" disabled style="width: 100%">
        </el-input-number>
      </el-form-item>
      <el-form-item label="状态" required>
        <el-select v-model="taskData.status" disabled>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实际开始日期" required>
        <el-date-picker v-model="taskData.actual_start_date" type="date" placeholder="选择日期" style="width: 100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="实际完成日期" required>
        <el-date-picker v-model="taskData.actual_end_date" type="date" placeholder="选择日期" style="width: 100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="实际用时(h)" required>
        <el-input-number v-model="taskData.actual_usage_time" :min="0.1" style="width: 100%"></el-input-number>
      </el-form-item>
      <el-form-item label="实际人天" required>
        <el-input-number v-model="taskData.actual_man_day" :min="0.1" style="width: 100%"></el-input-number>
      </el-form-item>
      <el-row style="justify-content: center;width: 100%;margin-top: 10px">
        <el-button type="primary" @click="submitCompleteTask">确定</el-button>
        <el-button @click="dialogs.showCompleteTask = false">取消</el-button>
      </el-row>
    </el-form>
  </el-dialog>


</template>

<script>

import {ElMessage, ElMessageBox} from "element-plus";

export default {
  name: 'TaskDetail',
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    statusList() {
      return this.$store.getters['core/getDictList']('prj_task_status');
    }
  },

  data() {
    return {
      mainData: {
        is_admin:false,
        is_remind: false
      },
      replyList: [],
      logList: [],
      userList:[],
      replyContent: '',
      queryReplyData: {
        main_data_id: this.parentData.id,
        main_data_type: 'task',
      },
      assignData: {
        id: this.parentData.id,
        charge_user_id: '',
      },
      nameData: {
        id: this.parentData.id,
        name: ''
      },
      progressData: {
        id: this.parentData.id,
        progress_percent: 0,
      },
      taskData: {
        id: this.parentData.id,
        status:'finish',
        progress_percent: 100,
        actual_start_date: '',
        actual_end_date: '',
      },
      dialogs: {
        showAssign: false,
        showChangeProgress: false,
        showCompleteTask: false,
        showUrgeReminder: false,
        showEditName: false
      },
      disableButton: true,
      claimButton: true,
      reminderButton: true,
      memberButton: true,
      abortButton: true,
      cancelAbortButton: true,
      pausedButton: true,
      cancelPausedButton: true,
    }
  },

  created() {
    this.loadUsers();
    this.getDetail();
    this.getReplyList();
  },

  methods: {
    async loadUsers() {
      this.userList = await this.$http('prjProjectService.getMemberAll', {project_id:this.parentData.project_id});
    },

    //获取任务详情
    async getDetail() {
      this.mainData = await this.$http('prjTaskService.getDetail',{id:this.parentData.id});
      // 更改任务状态后，对按钮进行禁用
      if (this.mainData.status === 'not_start' || this.mainData.status === 'on_progress'){
        if (this.mainData.is_admin){
          this.disableButton = false
          this.reminderButton = false
          this.abortButton = false
          this.pausedButton = false
        }
        if (!this.mainData.charge_user_id){
          this.claimButton = false
        }
        if (this.mainData.charge_user_id === this.mainData.current_user_id){
          this.memberButton = false
        }
      }
      if (this.mainData.status === 'finish'){
        this.disableButton = true
        this.reminderButton = true
        this.abortButton = true
        this.pausedButton = true
        this.memberButton = true
      }
      if (this.mainData.is_admin || this.mainData.charge_user_id === this.mainData.current_user_id){
        if (this.mainData.status === 'abort'){
          this.cancelAbortButton = false
        }
        if (this.mainData.status === 'paused'){
          this.cancelPausedButton = false
          this.abortButton = false
        }
      }
      await this.getLogList();

    },

    //获取回复列表
    async getReplyList() {
      this.replyList = await this.$http('prjReplyService.getReplyList', this.queryReplyData);
      await this.getLogList();
    },

    //获取日志列表
    async getLogList() {
      this.logList = await this.$http('prjLogService.getLogList', this.queryReplyData);
    },

    //删除回复
    async delReply(replayData) {
      ElMessageBox.confirm(
          '你是否要删除这条回复',
          '删除回复',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjReplyService.delReply',replayData);
        await this.getReplyList();
        ElMessage({
          type: 'success',
          message: '操作成功，已删除成功',
        })
      })
    },

    //提交回复
    async submitReply(){
      if(this.replyContent === ''){
        this.$message.error('回复内容为空')
        return;
      }
      let params = {
        main_data_id: this.parentData.id,
        main_data_type: 'task',
        content: this.replyContent
      };
      await this.$http('prjReplyService.addReply', params);
      this.$message.success('提交成功')
      await this.getReplyList();
      this.replyContent = ''
    },

    //更改责任人
    async submitAssign(){
      if(this.assignData.charge_user_id === ''){
        this.$message.error('未选择责任人')
        return;
      }
      await this.$http('prjTaskService.assign', this.assignData);
      this.$message.success('提交成功')
      await this.getDetail();
      this.assignData.charge_user_id = ''
      this.dialogs.showAssign = false
    },

    //任务领取
    submitClaimTask(){
      ElMessageBox.confirm(
          '你是否要领取这个任务？',
          '任务领取',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjTaskService.claimTask', this.mainData);
        this.claimButton = true;
        await this.getDetail();
        ElMessage({
          type: 'success',
          message: '操作成功，已领取',
        })
      })
    },

    //打开修改任务名称表单
    showEditName(){
      this.nameData.name = this.mainData.name;
      this.dialogs.showEditName = true
    },

    //修改任务名称
    async submitEditName(){
      await this.$http('prjTaskService.editTaskName', this.nameData);
      this.$message.success('提交成功')
      await this.getDetail();
      this.nameData.name = ''
      this.dialogs.showEditName = false
    },

    //打开更改进度表单
    showChangeProgress(){
      this.progressData.progress_percent = this.mainData.progress_percent;
      this.dialogs.showChangeProgress = true
    },

    //更改进度
    async submitChangeProgress(){
      await this.$http('prjTaskService.changeProgress', this.progressData);
      this.$message.success('提交成功')
      await this.getDetail();
      this.progressData.progress_percent = 0
      this.dialogs.showChangeProgress = false
    },

    //催促提醒
    async submitUrgeReminder(){
      ElMessageBox.confirm(
          '你是否需要通过在系统中发送消息进行催促？',
          '催促提醒',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjTaskService.urgeReminder', this.mainData);
        this.reminderButton = true
        ElMessage({
          type: 'success',
          message: '操作成功，已发送',
        })
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: '取消发送',
        })
      })
    },

    //打开完成任务表单
    showCompleteTask() {
      this.dialogs.showCompleteTask = true;
    },

    //完成任务
    async submitCompleteTask() {
      if (!this.taskData.actual_start_date) {
        this.$message.error("请选择实际开始日期！")
        return
      }
      if (!this.taskData.actual_end_date) {
        this.$message.error("请选择实际完成日期！")
        return
      }
      if (!this.taskData.actual_usage_time) {
        this.$message.error("请填写实际用时(h)！")
        return
      }
      if (!this.taskData.actual_man_day) {
        this.$message.error("请填写实际人天！")
        return
      }
      await this.$http('prjTaskService.completeTask', this.taskData);
      this.$message.success('提交成功')
      await this.getDetail();
      this.dialogs.showCompleteTask = false
    },

    //中止任务
    submitAbortTask() {
      ElMessageBox.confirm(
          '是否中止任务？',
          '中止任务',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjTaskService.abortTask', this.mainData);
        await this.getDetail();
        ElMessage({
          type: 'success',
          message: '操作成功，已中止任务',
        })
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: '取消中止',
        })
      })
    },

    //取消中止任务
    cancelAbortTask() {
      ElMessageBox.confirm(
          '是否取消中止任务？',
          '取消中止任务',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjTaskService.cancelAbortTask', this.mainData);
        await this.getDetail();
        ElMessage({
          type: 'success',
          message: '操作成功，已取消中止任务',
        })
      })
    },

    //挂起任务
    submitPausedTask() {
      ElMessageBox.confirm(
          '是否挂起任务？',
          '挂起任务',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjTaskService.pausedTask', this.mainData);
        await this.getDetail();
        ElMessage({
          type: 'success',
          message: '操作成功，已挂起任务',
        })
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: '取消中止',
        })
      })
    },

    //取消挂起任务
    cancelPausedTask() {
      ElMessageBox.confirm(
          '是否取消挂起任务？',
          '取消挂起任务',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjTaskService.cancelPausedTask', this.mainData);
        await this.getDetail();
        ElMessage({
          type: 'success',
          message: '操作成功，已取消挂起任务',
        })
      })
    },
  }

}

</script>

<style scoped>
.cke_read_only .cke_toolbox {
  display: none !important;
}
</style>